if (!customElements.get('thobes-picker')) {
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
    style: 'currency', currency: window.Shopify?.currency?.active || 'GBP'
  }).format(cents / 100);
  const root = () => window.Shopify?.routes?.root || '/';
  const readJSON = async response => {
    if (!/json|javascript/i.test(response.headers.get('content-type') || '')) throw new Error('The basket could not be confirmed.');
    return response.json();
  };
  class ThobesPicker extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.data = JSON.parse(this.querySelector('[data-thg-picker-data]').textContent);
      this.selects = [...this.querySelectorAll('[data-thg-option]')];
      this.colourIndex = this.selects.findIndex(s => /colou?r/i.test(s.dataset.optionName));
      this.image = this.querySelector('.thg-picker__image img');
      this.image.removeAttribute('srcset');
      const colours = this.selects[this.colourIndex];
      if (colours) {
        const stocked = this.data.variants.filter(v => v.available);
        const preferred = stocked.find(v => v.options[this.colourIndex] === this.dataset.defaultColour);
        colours.value = (preferred || stocked[0])?.options[this.colourIndex] || '';
        const seen = new Set();
        stocked.filter(v => v.image).forEach(v => {
          const colour = v.options[this.colourIndex];
          if (seen.has(colour)) return;
          seen.add(colour);
          const button = document.createElement('button');
          button.type = 'button'; button.dataset.thgColour = colour;
          button.setAttribute('aria-label', colour); button.title = colour;
          const image = document.createElement('img');
          image.src = v.image; image.alt = ''; image.width = 42; image.height = 56; image.loading = 'lazy';
          button.append(image);
          this.querySelector('[data-thg-swatches]').append(button);
        });
      }
      this.addEventListener('change', () => this.update());
      this.addEventListener('click', event => {
        const swatch = event.target.closest('[data-thg-colour]');
        if (!swatch || this.closest('thobes-pair').busy) return;
        colours.value = swatch.dataset.thgColour; this.update();
      });
      this.update();
    }
    update() {
      const selected = this.selects.map(s => s.value);
      this.variant = selected.every(Boolean) ? this.data.variants.find(v => v.options.every((value, i) => value === selected[i])) : null;
      this.dataset.variantId = this.variant?.id || '';
      this.selects.forEach((select, index) => {
        for (const option of select.options) {
          if (!option.value) continue;
          const matching = this.data.variants.filter(v => v.options[index] === option.value && (index === this.colourIndex || this.colourIndex < 0 || !selected[this.colourIndex] || v.options[this.colourIndex] === selected[this.colourIndex]));
          option.disabled = !matching.some(v => v.available);
          option.textContent = option.value + (option.disabled ? ' - sold out' : '');
        }
      });
      const imageVariant = this.variant?.image ? this.variant : this.data.variants.find(v => v.available && v.image && v.options[this.colourIndex] === selected[this.colourIndex]);
      this.image.hidden = !imageVariant?.image;
      this.querySelector('[data-thg-image-note]').hidden = !!imageVariant?.image;
      if (imageVariant?.image) {
        this.image.src = imageVariant.image;
        this.image.alt = this.dataset.label + ' thobe in ' + selected[this.colourIndex];
      }
      this.querySelectorAll('[data-thg-colour]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.thgColour === selected[this.colourIndex])));
      const candidates = this.data.variants.filter(v => v.available && (this.colourIndex < 0 || v.options[this.colourIndex] === selected[this.colourIndex]));
      const prices = candidates.map(v => v.price);
      this.querySelector('[data-thg-picker-price]').textContent = this.variant ? money(this.variant.price) : prices.length ? (new Set(prices).size > 1 ? 'From ' : '') + money(Math.min(...prices)) : '';
      this.querySelectorAll('[data-thg-picker-link]').forEach(a => a.href = this.data.url + (this.variant ? '?variant=' + this.variant.id : ''));
      this.querySelector('[data-thg-picker-status]').textContent = this.variant ? (this.variant.available ? 'In stock: ' + this.variant.title : 'This colour and size is sold out') : selected.every(Boolean) ? 'This combination is unavailable' : 'Choose ' + this.selects.filter((s, i) => !selected[i]).map(s => s.dataset.optionName.toLowerCase().replace('color', 'colour')).join(' and ');
      this.querySelector('[data-thg-add]').disabled = !this.variant?.available || !!this.closest('thobes-pair').busy || !!this.closest('thobes-pair').uncertain;
      this.dispatchEvent(new CustomEvent('thg:selection', {bubbles: true}));
    }
  }
  class ThobesPair extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('thg:selection', () => this.update());
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-thg-add]');
        if (!button || button.disabled) return;
        const pickers = button.dataset.thgAdd === 'both' ? [...this.querySelectorAll('thobes-picker')] : [button.closest('thobes-picker')];
        this.add(pickers, button);
      });
      this.update();
    }
    update() {
      const pickers = [...this.querySelectorAll('thobes-picker')];
      const complete = pickers.every(p => p.variant?.available);
      const both = this.querySelector('[data-thg-add="both"]');
      if (both) both.disabled = !complete || !!this.busy || !!this.uncertain;
      const total = this.querySelector('[data-thg-pair-total]');
      if (total) total.textContent = complete ? 'Together ' + money(pickers.reduce((sum, p) => sum + p.variant.price, 0)) : 'Choose a colour and size for each';
    }
    async add(pickers, button) {
      const message = this.querySelector('[data-thg-pair-status]');
      if (ThobesPair.inFlight || this.uncertain) {
        message.textContent = this.uncertain ? 'Check your basket before adding again.' : 'Please wait while your basket is updated.';
        return;
      }
      if (pickers.some(p => !p.variant?.available)) return;
      const chosen = pickers.map(p => ({id: p.variant.id, quantity: 1, label: p.dataset.label + ' ' + p.variant.title}));
      ThobesPair.inFlight = true; this.busy = true; this.setAttribute('aria-busy', 'true');
      this.querySelectorAll('[data-thg-add],fieldset').forEach(el => el.disabled = true);
      message.textContent = 'Adding to your basket...';
      let attempted = false;
      try {
        const beforeResponse = await fetch(root() + 'cart.js', {cache: 'no-store', signal: AbortSignal.timeout(12000)});
        const before = await readJSON(beforeResponse);
        if (!beforeResponse.ok || !Array.isArray(before.items)) throw new Error('Your basket could not be checked. Nothing was added.');
        let addedResponse, problem;
        attempted = true;
        try {
          const response = await fetch(root() + 'cart/add.js', {
            method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest'},
            body: JSON.stringify({items: chosen.map(({id, quantity}) => ({id, quantity})), sections: 'cart-ajax', sections_url: location.pathname}),
            signal: AbortSignal.timeout(18000)
          });
          addedResponse = await readJSON(response);
          if (!response.ok) problem = typeof addedResponse.description === 'string' ? addedResponse.description : 'Availability has changed.';
        } catch (error) { problem = error.message; }
        // Read back even a failed multi-add: Shopify can accept only part of a request.
        const afterResponse = await fetch(root() + 'cart.js', {cache: 'no-store', signal: AbortSignal.timeout(12000)});
        const after = await readJSON(afterResponse);
        if (!afterResponse.ok || !Array.isArray(after.items)) throw new Error('Your basket could not be confirmed.');
        const quantity = (cart, id) => cart.items.filter(i => String(i.variant_id) === String(id)).reduce((n, i) => n + i.quantity, 0);
        const accepted = chosen.filter(item => quantity(after, item.id) - quantity(before, item.id) >= item.quantity);
        const missing = chosen.filter(item => !accepted.includes(item));
        message.textContent = [accepted.length ? 'Added ' + accepted.map(i => i.label).join(' and ') + ' to your basket.' : 'Nothing was added.', missing.length ? missing.map(i => i.label).join(' and ') + (missing.length > 1 ? ' were not added. ' : ' was not added. ') + (problem || 'Please check availability and try again.') : ''].filter(Boolean).join(' ');
        this.querySelector('[data-thg-cart-link]').hidden = false;
        if (accepted.length) {
          let sections = addedResponse?.sections;
          if (!sections?.['cart-ajax']) {
            try { sections = await readJSON(await fetch(root() + '?sections=cart-ajax', {signal: AbortSignal.timeout(8000)})); } catch {}
          }
          if (sections?.['cart-ajax']) button.dispatchEvent(new CustomEvent('ajaxProduct:added', {bubbles: true, detail: {product: {...addedResponse, sections}, addToCartBtn: button, preventCartOpen: missing.length > 0}}));
        }
      } catch (error) {
        this.uncertain = attempted;
        message.textContent = attempted ? 'We could not confirm every item. Check your basket before adding again.' : 'Your basket could not be checked. Nothing was added. Please try again.';
        this.querySelector('[data-thg-cart-link]').hidden = false;
      } finally {
        ThobesPair.inFlight = false; this.busy = false; this.removeAttribute('aria-busy');
        this.querySelectorAll('fieldset').forEach(el => el.disabled = false);
        this.querySelectorAll('thobes-picker').forEach(p => p.update());
        if (this.uncertain) this.querySelectorAll('[data-thg-add]').forEach(b => b.disabled = true);
        this.update();
      }
    }
  }
  customElements.define('thobes-picker', ThobesPicker);
  customElements.define('thobes-pair', ThobesPair);
  document.querySelectorAll('[data-thg-pair-switch]').forEach(switcher => {
    switcher.addEventListener('click', event => {
      const button = event.target.closest('[data-thg-style]');
      if (!button || ThobesPair.inFlight) return;
      switcher.querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      switcher.parentElement.querySelectorAll('[data-thg-style-panel]').forEach(p => p.hidden = p.dataset.thgStylePanel !== button.dataset.thgStyle);
    });
  });
}
if (!customElements.get('thobes-catalogue')) {
  customElements.define('thobes-catalogue', class extends HTMLElement {
    connectedCallback() {
      if(this.ready)return;this.ready=true;
      const grid=this.querySelector('[data-thg-grid]'),items=[...grid.children];
      this.addEventListener('click',event=>{
        const button=event.target.closest('[data-thg-filter]');if(!button)return;
        this.querySelectorAll('[data-thg-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
        items.forEach(item=>item.hidden=button.dataset.thgFilter!=='all'&&item.dataset.thgGroup!==button.dataset.thgFilter);
        this.querySelector('[data-thg-empty]').hidden=items.some(item=>!item.hidden);
      });
      this.querySelector('[data-thg-sort]')?.addEventListener('change',event=>{
        const mode=event.target.value;
        const ordered=[...items].sort((a,b)=>mode==='price-low'?Number(a.dataset.thgPrice)-Number(b.dataset.thgPrice):mode==='price-high'?Number(b.dataset.thgPrice)-Number(a.dataset.thgPrice):Number(a.dataset.thgOrder)-Number(b.dataset.thgOrder));
        ordered.forEach(item=>grid.append(item));
      });
    }
  });
}
if(!customElements.get('thobes-pdp-tools')){
  customElements.define('thobes-pdp-tools',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;this.ready=true;
      this.abort=new AbortController();
      this.variants=JSON.parse(this.querySelector('[data-thg-variants]').textContent);
      this.sticky=this.querySelector('.thg-sticky');
      this.scope=this.closest('.thg-pdp-scope');
      this.update=()=>{
        const buy=this.scope.querySelector('block-buy-buttons[data-product-id="'+this.dataset.productId+'"]');
        const native=buy?.querySelector('button[name="add"]');
        const input=buy?.querySelector('input[name="id"]');
        if(!native||!input){this.sticky.hidden=true;return;}
        this.native=native;const variant=this.variants.find(v=>String(v.id)===input.value);
        this.querySelector('[data-thg-price]').textContent=variant?new Intl.NumberFormat(document.documentElement.lang||'en-GB',{style:'currency',currency:window.Shopify?.currency?.active||'GBP'}).format(variant.price/100):'';
        this.querySelector('[data-thg-choice]').textContent=variant?.title||'';
        const proxy=this.querySelector('[data-thg-submit]');
        proxy.textContent=native.textContent.trim();proxy.disabled=native.disabled;
        this.sticky.hidden=false;
      };
      this.schedule=()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(this.update);};
      this.observer=new MutationObserver(this.schedule);
      const product=this.scope.querySelector('.product-single__meta')||this.scope.querySelector('block-buy-buttons')?.parentElement;
      if(product&&!product.contains(this))this.observer.observe(product,{childList:true,subtree:true,attributes:true,attributeFilter:['value','disabled','checked']});
      this.scope.addEventListener('change',()=>{this.schedule();setTimeout(this.schedule,160);},{signal:this.abort.signal});
      this.querySelector('[data-thg-submit]').addEventListener('click',()=>{this.update();if(this.native&&!this.native.disabled)this.native.click();},{signal:this.abort.signal});
      this.update();
    }
    disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();cancelAnimationFrame(this.frame);}
  });
}
